// empex（FAQページのコピーボタン用）
function copy(target) {
  navigator.clipboard.writeText(location.protocol + '//' + location.hostname + location.pathname + '#' + target.parentNode.id);

  let toast = document.createElement("div");
  toast.textContent = "リンクをクリップボードにコピーしました";
  toast.style.backgroundColor = "#333";
  toast.style.color = "#fff";
  toast.style.borderRadius = "0.5rem";
  toast.style.padding = "1rem";
  toast.style.position = "fixed";
  toast.style.bottom = "1rem";
  toast.style.right = "1rem";
  toast.style.opacity = "0";
  toast.style.transition = "opacity 0.5s ease-in-out";
  toast.style.zIndex = "9999";
  document.body.appendChild(toast);

  setTimeout(function() {
    toast.style.opacity = "1";
    setTimeout(function() {
      toast.style.opacity = "0";
      setTimeout(function() {
        document.body.removeChild(toast);
      }, 300);
    }, 2000);
  }, 0);
}
